import React from 'react'
import {sanitize} from 'dompurify';
import LoanEstimateCard from "./loanEstimateCard";

export default class NotesCard extends React.Component {

    getNotes = () => {
        return this.props.notes.map(d => (
            <div className="my-1" key={d}>
                {d}
            </div>
        ))
    }

    render() {
        return (
            <div>
                <div className="card mb-6 has-background-info-light">
                    <div className="card-content is-flex is-align-content-center has-icons-and-text-aligned has-text-weight-semibold pb-1">
                        {/* <i className={'fa fa-info has-text-info-dark mr-4 '}/> */}
                        {this.props.title}
                    </div>
                    <div className="card-content mt-0 pt-0">
                        {this.getNotes()}
                    </div>
                </div>
            </div>
        )
    }
}